import React from 'react';
import { Controller } from 'react-hook-form';
import PropTypes from 'prop-types';
import { intlShape } from 'react-intl';
import { voucherUpdateReasons } from 'constants/vouchers';
import { StyledDropdown } from './VoucherEditReasonsSelect.styles';

const VoucherEditReasonSelect = ({ intl: { formatMessage }, control }) => (
  <div>
    <Controller
      rules={{ required: true }}
      control={control}
      name="reasonOption"
      render={({ field }) => (
        <StyledDropdown data-cy="reason-option" {...field}>
          <option value="" selected>
            {formatMessage({ id: 'vouchers.defaultReason' })}
          </option>
          {voucherUpdateReasons.map(({ value: optionValue, label: optionLabel }) => (
            <option key={optionValue} value={optionValue}>
              {optionLabel}
            </option>
          ))}
        </StyledDropdown>
      )}
    />
  </div>
);

VoucherEditReasonSelect.propTypes = {
  control: PropTypes.func,
  intl: intlShape
};

export default VoucherEditReasonSelect;
